import { css } from '@emotion/css';

export const linkMarkMenuPopper = css`
  // If one wants to use the menu in the modal, we need to set
  // the z-index higher than 1300 which is the z-index of the modal.
  z-index: 1301;
`;
